import { AppBar, Button, Checkbox, CircularProgress, createStyles, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, IconButton, InputLabel, makeStyles, MenuItem, Radio, RadioGroup, Select, Step, StepButton, Stepper, Tab, Tabs, TextField, Theme, Toolbar, Typography } from '@material-ui/core';
import { Guid } from 'guid-typescript';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import { _PortalState } from '../../helpers/state';
import * as microsoftTeams from "@microsoft/teams-js";
import { AccountCircle, Add, BorderRight, Close, ContactSupportOutlined, Save } from '@material-ui/icons';
import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason } from '@material-ui/lab';

export const InterviewsForm: React.FC<InterviewsFormProps> = (props: InterviewsFormProps) => {


    const { register, handleSubmit, errors, control, reset } = useForm();

    const [value, setValue] = React.useState(0);
    const [anonymous, setAnonymous] = React.useState<boolean>(false);
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState<any[]>([]);
    const [customer, setCustomer] = React.useState<any>();
    const loading = open && options.length === 0;

    const { data, error, refetch } = useQuery<InterviewDialogData>(['interviews', props.experimentId], async () => {
        return new Promise<any>(async (resolve, reject) => {
            // console.log(props.experimentId);
            if (props.experimentId) {
                microsoftTeams.initialize(() => {
                    microsoftTeams.authentication.getAuthToken({
                        successCallback: (token: string) => {
                            fetch(_PortalState.ApiEndpoint + "/experiment?experimentid=" + props.experimentId + "&groupid=" + _PortalState.teamsContext.groupId,
                                {
                                    method: 'GET',
                                    headers:
                                        { "Authorization": "bearer " + token }
                                })
                                .then(res => res.json())
                                .then((res: any[]) => {
                                    // console.log(res);
                                    if (res.length > 0)

                                        fetch(_PortalState.ApiEndpoint + "/interview?experimentid=" + props.experimentId,
                                            {
                                                method: 'GET',
                                                headers:
                                                    { "Authorization": "bearer " + token }
                                            })
                                            .then(res => res.json())
                                            .then((res2: any[]) => {
                                                resolve({
                                                    experiment: res[0],
                                                    interviews: res2
                                                });

                                            });
                                });

                        }
                    })
                });
            }
            else {
                resolve(null);
            }
        });
    });

    React.useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {
            var customers: any[] = [];
            _PortalState.graphtoken().then(async token => {
                if (_PortalState.teamsContext.groupId) {
                    await fetch('https://graph.microsoft.com/v1.0/groups/' + _PortalState.teamsContext.groupId + '/sites/root/lists',
                        { headers: { 'authorization': 'Bearer ' + token } })
                        .then(res => res.json())
                        .then(async lists => {
                            if (lists.value) {
                                for (const list of lists.value.filter((l: any) => l.list.template === 'genericList' && l.list.hidden === false)) {
                                    await fetch('https://graph.microsoft.com/v1.0/groups/' + _PortalState.teamsContext.groupId + '/sites/root/lists/' + list.id + '/items?$expand=fields',
                                        { headers: { 'authorization': 'Bearer ' + token } })
                                        .then(res => res.json())
                                        .then(items => {
                                            for (const item of items.value) {
                                                customers.push({
                                                    listid: list.id,
                                                    listname: list.displayName,
                                                    id: item.id,
                                                    name: item.fields.Title
                                                });
                                            }
                                        })
                                }


                            }
                            console.log(customers);
                            if (active) {
                                setOptions(customers);
                            }
                        })
                }
            })

            console.log(customers);

            // if (active) {
            //     setOptions(customers);
            // }
        })();

        return () => {
            active = false;
        };
    }, [loading]);

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const onSubmit = (formData: any) => {
        console.log(data);
        console.log(Object.keys(formData).filter(d => d !== 'customer').map(d => { return { question: data?.experiment.data[d], answer: formData[d] } }))

        microsoftTeams.authentication.getAuthToken({
            successCallback: (token: string) => {
                fetch(_PortalState.ApiEndpoint + "/interview",
                    {
                        method: 'POST',
                        headers:
                            { "Authorization": "bearer " + token },
                        body: JSON.stringify({
                            experimentId: props.experimentId,
                            groupid: _PortalState.teamsContext.groupId,
                            createdby: _PortalState.teamsContext.userObjectId,
                            anonymous: anonymous,
                            anonymouscustomer: anonymous ? formData.anonymouscustomer : undefined,
                            customer: !anonymous ? customer : undefined,
                            questions: Object.keys(formData).filter(d => d !== 'customer').map(d => { return { question: data?.experiment.data[d], answer: formData[d] } })
                        })
                    })
                    .then((res: any) => {
                        // console.log(res);
                        reset();
                    })
                    .finally(() => {
                        refetch();
                    })

            }
        })
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    const formfieldstyle = { margin: '10px 0' };

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            appBar: {
                position: 'relative',
            },
            title: {
                marginLeft: theme.spacing(2),
                flex: 1,
            },
        }),
    );
    const classes = useStyles();

    if (data && data.experiment && data.interviews)
        return (
            <>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={props.onClose} aria-label="close">
                            <Close />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Interviews on experiment {data.experiment.data.name}
                        </Typography>
                        {/* <Button type="submit" form="hook-form" autoFocus color="inherit">
                            {step === (steps.length - 1) ? 'Save' : 'Next'}
                        </Button> */}
                    </Toolbar>
                </AppBar>

                {/* <DialogTitle id="form-dialog-title">
                    Interviews on experiment {data.experiment.data.name}
                </DialogTitle> */}


                <DialogContent>
                    <div style={{ display: 'flex', height: '80vh' }}>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            indicatorColor="primary"
                            onChange={handleChange}
                            style={{ width: '250px', borderRight: '1px solid lightgrey' }}
                        >
                            <Tab value={0} label={<div style={{ textAlign: 'left', width: '100%' }}><Add style={{ verticalAlign: 'middle' }} /> Add new</div>} />
                            {data.interviews.map((value, index, array) => {
                                return (<Tab key={value.id} label={<div style={{ textAlign: 'left', width: '100%' }}><AccountCircle style={{ verticalAlign: 'middle' }} /> {value.customer ? value.customer.name : value.anonymouscustomer}</div>} value={index + 1} />)
                            })}
                        </Tabs>
                        <div style={{ width: '100%', height: '500px', padding: '0 20px 0 20px' }}>
                            {value === 0 &&
                                <div>
                                    <Typography variant="overline" display="block" gutterBottom>
                                        Press tab to go to the next field
                                    </Typography>
                                    <form onSubmit={handleSubmit(onSubmit)} id="hook-form">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={anonymous}
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                        setAnonymous(checked);
                                                    }}
                                                    name="anonymous"
                                                    color="primary"
                                                />
                                            }
                                            style={formfieldstyle}
                                            label="Interview is anonymous"
                                        />
                                        <TextField
                                            style={{ margin: '10px 0', width: '100%', display: anonymous ? '' : 'none' }}
                                            multiline
                                            fullWidth
                                            autoComplete="off"
                                            required={anonymous}
                                            // placeholder={data ? '' : undefined}
                                            // key={f.field}
                                            // defaultValue={data && (data as any).data ? (data as any).data[f.field] : ''}
                                            variant="outlined"
                                            inputRef={register({})}
                                            name={"anonymouscustomer"}
                                            label="Name"
                                        />

                                        <Autocomplete
                                            style={{ width: '100%', display: anonymous ? 'none' : '' }}
                                            open={open}
                                            onOpen={() => {
                                                setOpen(true);
                                            }}
                                            onClose={() => {
                                                setOpen(false);
                                            }}
                                            getOptionSelected={(option, value) => option.name === value.name}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event: React.ChangeEvent<{}>, value: any, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<any> | undefined) => {
                                                // console.log(reason, details, value);
                                                setCustomer(value);
                                            }}
                                            options={options}
                                            loading={loading}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Customer"
                                                    style={formfieldstyle}
                                                    variant="outlined"
                                                    required={!anonymous}
                                                    inputRef={register({})}
                                                    name={"customer"}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                        {Object.keys(data.experiment.data).filter(i => i.indexOf('interview') === 0 && data.experiment.data[i] !== "").map((value, index, array) => {
                                            return (<TextField
                                                key={'q' + index}
                                                required
                                                style={formfieldstyle}
                                                multiline
                                                fullWidth
                                                autoComplete="off"
                                                variant="outlined"
                                                // InputLabelProps={{ shrink: true }}
                                                // placeholder={data ? '' : undefined}
                                                // key={f.field}
                                                // defaultValue={data && (data as any).data ? (data as any).data[f.field] : ''}

                                                inputRef={register({})}
                                                name={value}
                                                label={data.experiment.data[value]}
                                            />)
                                        })}


                                        <TextField
                                            required
                                            // InputLabelProps={{ shrink: true }}
                                            // rowsMax={4}
                                            style={formfieldstyle}
                                            rows={5}
                                            variant="outlined"
                                            multiline
                                            fullWidth
                                            autoComplete="off"
                                            // placeholder={data ? '' : undefined}
                                            // key={f.field}                                            

                                            inputRef={register({})}
                                            name={"Learnings"}
                                            label={"What did you learn from this customer?"}
                                        />

                                        <FormLabel required style={{ fontSize: 'medium' }} >Did this customer validate or invalidate the hypothesis?</FormLabel>
                                        <Controller
                                            as={
                                                <RadioGroup style={{ margin: '5px' }}>
                                                    <FormControlLabel control={<Radio required={true} />} value="Validate" label="Validate" />
                                                    <FormControlLabel control={<Radio required={true} />} value="Invalidate" label="Invalidate" />
                                                    <FormControlLabel control={<Radio required={true} />} value="Inconclusive" label="Inconclusive" />
                                                </RadioGroup>
                                            }
                                            label="Did this customer validate or invalidate the hypothesis?"
                                            name="Conclusion"

                                            control={control}
                                            defaultValue={""}
                                            rules={{ required: true }}
                                        />



                                        <div style={{ textAlign: 'right', padding: '20px 0 0 0 ' }}>
                                            <Button type="submit" form="hook-form" color="primary" startIcon={<Save />} variant="contained">
                                                Save
                                            </Button>
                                        </div>

                                    </form>
                                </div>
                            }
                            {value !== 0 &&
                                <div>
                                    <form onSubmit={handleSubmit(onSubmit)} id="hook-form">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={data.interviews[value - 1].anonymous}
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                        setAnonymous(checked);
                                                    }}
                                                    name="anonymous"
                                                    color="primary"
                                                    disabled
                                                />
                                            }
                                            style={formfieldstyle}
                                            label="Interview is anonymous"
                                        />
                                        <TextField
                                            disabled
                                            required
                                            style={formfieldstyle}
                                            multiline
                                            fullWidth
                                            autoComplete="off"
                                            value={data.interviews[value - 1].anonymous ? data.interviews[value - 1].anonymouscustomer : data.interviews[value - 1].customer.name}
                                            inputRef={register({})}
                                            name={"customer"}
                                            label="Customer name"
                                        />
                                        {data.interviews[value - 1].questions.map((value: any) => {
                                            return (<TextField
                                                disabled
                                                required
                                                style={formfieldstyle}
                                                multiline
                                                fullWidth
                                                autoComplete="off"
                                                value={value.answer}
                                                inputRef={register({})}
                                                name={value.question}
                                                label={value.question}
                                            />)
                                        })}
                                    </form>
                                </div>
                            }
                        </div>
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose} color="primary">
                        Close
                    </Button>
                    {/* <Button type="submit" form="hook-form" color="primary">
                        {step === (steps.length - 1) ? 'Save' : 'Next'}
                    </Button>  */}
                </DialogActions>


            </>
        );

    return <div></div>
}


interface InterviewsFormProps {
    phase: any;
    experimentId: string;
    onClose: () => void;
    // onSave: (data: any) => void;

}

interface InterviewDialogData {
    experiment: any;
    interviews: any[];
}